import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Config from "./Config";
import { useAppFeedback } from "./useAppFeedback";
import FieldError from "./FieldError";

function Login() {
  let navigate = useNavigate();
  const location = useLocation();
  const { showError, showSuccess } = useAppFeedback();
  const tokens = Cookies.get("a_token");
  const redirectTarget = location.state?.from?.pathname || "/dashboard";

  const [formerror, setError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [login, setLogin] = useState({ username: "", password: "" });

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setLogin({ ...login, [name]: value });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = "username is required!";
    }
    if (!values.password) {
      errors.password = "password is required!";
    }
    return errors;
  };
  const PostData = async (e) => {
    e.preventDefault();
    const { username, password } = login;
    const ress = validate(login);
    setError(ress);
    setIsSubmit(true);
    if (!ress.username && !ress.password) {
      const res = await fetch(`${Config.apiurl}/api/v1/crm/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
          password: password,
        }),
      });
      const data1 = await res.json();
      const data = data1.data;
      if (res.status === 200) {
        Cookies.set("a_token", data[0].token);
        Cookies.set("User_type", data[0].userType);
        Cookies.set("loginStatus", data1.status);
        Cookies.set("reToken", data[0].reToken);
        showSuccess("Sucessfully Loged In", { redirectTo: redirectTarget, redirectDelay: 400 });
      } else {
        showError("Invalid user");
      }
    }
  };
  useEffect(() => {
    if (Object.keys(formerror).length === 0 && isSubmit) {
    }
  }, [formerror]);

  useEffect(() => {
    if (tokens) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate, tokens]);

  return (
    <div>
      <div className="container-scroller">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth px-0">
            <div className="row w-100 mx-0">
              <div className="col-lg-4 mx-auto">
                <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                  <h3 style={{ color: "black" }}>Sign-in</h3>
                  <h6 className="font-weight-light">Sign in to continue.</h6>
                  <form className="pt-3">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        id="exampleInputEmail1"
                        name="username"
                        value={login.username}
                        onChange={handleInputs}
                        placeholder="Username"
                        style={{ color: "black" }}
                      />
                      <FieldError message={formerror.username} />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control form-control-lg"
                        id="exampleInputPassword1"
                        name="password"
                        value={login.password}
                        onChange={handleInputs}
                        placeholder="Password"
                        style={{ color: "black" }}
                      />
                      <FieldError message={formerror.password} />
                    </div>
                    <div className="mt-3">
                      <button
                        onClick={PostData}
                        style={{
                          width: 200,
                          height: 50,
                          backgroundColor: "#00bfff",
                          border: "none",
                        }}
                      >
                        Sign-in
                      </button>
                    </div>

                    <div className="my-2 d-flex justify-content-between align-items-center">
                      {/* <div className="form-check">
                  <label className="form-check-label text-muted">
                    <input type="checkbox" className="form-check-input" />
                    Keep me signed in
                    <i className="input-helper" /></label>
                </div> */}
                      {/* <a href="/register" className="auth-link text-black">Register Now?</a> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
